import { BrowserRouter as Router, Route, Routes, Switch } from 'react-router-dom';
import LoginScreen from './screens/LoginScreen';
import HomeScreen from './screens/HomeScreen';
import './App.css';

function App() {
  const token = localStorage.getItem('token');

  return (
    <Router>
      <Routes>
        <Route path="/" element={token ? <HomeScreen /> : <LoginScreen />} />
        <Route path="/home" element={token ? <HomeScreen /> : <LoginScreen />} />
      </Routes>
    </Router>
  );
  // return (<h6>node_modules installed.</h6>)
}

export default App;